import { render, staticRenderFns } from "./NoticeRecordTemp.vue?vue&type=template&id=9cf79ff4&scoped=true"
import script from "./NoticeRecordTemp.vue?vue&type=script&lang=js"
export * from "./NoticeRecordTemp.vue?vue&type=script&lang=js"
import style0 from "./NoticeRecordTemp.vue?vue&type=style&index=0&id=9cf79ff4&prod&scoped=true&less=true&lang=css"
import style1 from "./NoticeRecordTemp.vue?vue&type=style&index=1&id=9cf79ff4&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf79ff4",
  null
  
)

export default component.exports